// THE DEMO HANDS ON WHAT BROUGHT THE VISITOR (2026-09-30)
//
// Chris, that night, of a shop whose signup row said only "the demo": "cold find?" It was not. The person had tapped
// an ad inside Instagram, opened the demo there, opened it again in Chrome and signed up from Chrome the next day.
// The demo sat in the middle of that road and kept nothing, by design: a shop's form beacons nothing about a person,
// because it is the one page holding real client PII, and the demo is that form. So the site on the far side met a
// browser that knew only "I came from demo.waivers.tattoo", which is a hop inside the product and not a source, and
// the ad got no credit for a shop that later paid. His answer when one row could not be explained at all: ""i can't
// tell" means we've failed you and can do better."
//
// So the DEMO, and only the demo, hands on what it was handed. A link from the site to the demo carries the visit's
// touches as `?wt_ft=<token>` (first-touch.ts is the format and the rules, byte for byte the site's own copy), the
// demo leaves the token on its address (so "open in my browser" out of Instagram keeps it), and the two wordmark
// links back to the site leave with it. When the demo is opened with NO token (a link in a comment, a message, a
// typed address) it makes one from its own arrival: the tags on its address and the outside site that referred it.
//
// WHAT THIS IS NOT. Nothing here is beaconed, stored or sent: the token is read off the address and written onto
// two links. A real shop's form never calls it (the wordmark links are the demo chrome's alone), and a client's page
// takes nothing of ours in its address, which is first-touch.ts's own rule (CARRY_HOSTS names the demo and no shop).
//
// THE RULES LIVE IN first-touch.ts since 2026-10-17 (TW-0330): what a demo's arrival says and which token it hands on
// (`demoArrival`, `demoCarryToken`) were this file's own until the link page's, the deposit page's, the booking page's and
// the website's demos began handing it on too, and moved there unchanged so the five demos read one rule. This file is the
// form's glue alone: the token read once, and the two wordmark links.
import { carryOnLink, demoCarryToken } from "./first-touch";

// Read ONCE, when the page starts: the arrival's time is when the demo was opened, never when a link was drawn, and
// the address is read before anything (try.ts, the demo's own dials) rewrites it.
let atStart: string | null = null;
function tokenAtStart(): string {
  if (atStart === null) {
    try {
      atStart = demoCarryToken(window.location.search, document.referrer, window.location.host, Date.now());
    } catch {
      atStart = "";
    }
  }
  return atStart;
}

/** A link from the demo chrome to one of our sites, with what brought the visitor on it. The href unchanged when
 *  there is nothing to hand on, or when it is not one of our sites. */
export function siteHref(href: string): string {
  try {
    return carryOnLink(href, tokenAtStart(), window.location.host) ?? href;
  } catch {
    return href;
  }
}

/** Testing seam: forget the token read at start. */
export function resetCarry(): void {
  atStart = null;
}
